import type { PrescriptionGapPolicy } from 'types/prescription';

export const TEST_ID = 'gapPolicyPicker';

export const GAP_POLICY_MASK: PrescriptionGapPolicy = 'MASK';

export const GAP_POLICY_BASE_RATE: PrescriptionGapPolicy = 'BASE_RATE';

// Order must stay stable — the active index passed to LabeledToggle is
// derived from the position in this list.
export const GAP_POLICY_VALUES: readonly PrescriptionGapPolicy[] = [
    GAP_POLICY_MASK,
    GAP_POLICY_BASE_RATE
] as const;
